import React from "react";
import Body from "./Body";
import { useProgram } from './context'

export default function Content(){
  const { internship_program, jobs, isLoading } = useProgram();

  return (<Body internship_program={internship_program} jobs={jobs} />);
}